export * from "./patient-portal-verify-pin.guard";
export * from "./patient-portal-dashboard-access.guard";



// WEBPACK FOOTER //
// ./src/app/shared/guard/patient-portal/index.ts